import template from './issuedFollowUp.html';
import controller from './issuedFollowUpCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    tab: '<',
    filterData: '<',
    dateSentFeature: '<',
    filterUpdateCount: '<',
    refreshCount: '<',
    onTableDataLoaded: '&',
    onSendModal: '&',
    viewContact: '&',
  },
};
